function sortSmallTolarge(obj) {
  return obj.sort((a,b) => a.length - b.length);
}

export function splitSizeOptionIntoWaistLength(options, waist, length) {
    const waistLengthOptions = {
      'waist': [],
      'length': []
    }

    const resolveIsDisabled = (value) => {
      const option = options.find((option) => option.value === `${value}/${length}`);
      if (option) return option.isDisabled;
      return true;

    }
    
    for(let idx = 0; idx < options.length; idx++) {
      if (!waistLengthOptions['waist'].find((obj) => obj.key === options[idx].key.split('/')[0])) {
        waistLengthOptions['waist'].push({
          ...options[idx],
          key: options[idx].key.split('/')[0],
          labelText: options[idx].labelText.split('/')[0],
          waist: options[idx].value.split('/')[0],
          selected: options[idx].value.split('/')[0] === waist,
          isDisabled: resolveIsDisabled(options[idx].value.split('/')[0]),
          option: 'Waist'
        })
      }
      if (!waistLengthOptions['length'].find((obj) => obj.key === options[idx].key.split('/')[1])) {
        waistLengthOptions['length'].push({
          ...options[idx],
          key: options[idx].key.split('/')[1],
          labelText: options[idx].labelText.split('/')[1],
          length: options[idx].value.split('/')[1],
          selected: options[idx].value.split('/')[1] === length,
          isDisabled: false,
          option: 'length'
        })
      }
    }

    sortSmallTolarge(waistLengthOptions['length']);

    return waistLengthOptions;
}